// extracted by mini-css-extract-plugin
module.exports = {"container":"gridPlayer__container___26kJB"};